import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PasswordResetRequest } from "./PasswordResetRequestAPI";

// Async thunk to send email
export const sendEmail = createAsyncThunk(
  "email/sendEmail",
  async (email, { rejectWithValue }) => {
    try {
      const data = await PasswordResetRequest(email); // Already parsed JSON

      console.log("response slice", data);

      return data; // No need to re-parse JSON
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const emailSlice = createSlice({
  name: "email",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendEmail.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(sendEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(sendEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default emailSlice.reducer;
